import Table from "../../../components/Table/Table";
import Badge from "../../../components/Badge";

const ReferralWithdrawHistory = () => {
  const withdrawColumns = [
    { name: "Date", selector: row => row.date || "N/A", sortable: true },
    { name: "Amount", selector: row => row.amount || "N/A", sortable: true },
    { name: "Account Info", selector: row => row.account_info || "N/A", sortable: true },
    { name: "Status", selector: row => row.status || "Pending", sortable: true, cell: row => <Badge status={row.status || "Pending"} /> }
  ];

  return (
    <main className="ref-dash-main ref-settings-main">
      <div className="ref-settings-card" style={{ padding: "32px 0" }}>
        <div className="ref-referrers-section" style={{ marginTop: 0, border: "none", padding: "0 32px" }}>
          <div className="ref-table-header">
            <div className="ref-table-title">
              <h2>Withdrawal history</h2>
              <p>See all your withdrawal History</p>
            </div>
          </div>

          <Table data={[]} columns={withdrawColumns} pagination />
        </div>
      </div>
    </main>
  );
};

export default ReferralWithdrawHistory;
